import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Button, Card } from 'antd';
import PaginatedReduxTable from '../paginated_redux_table/PaginatedReduxTable';
import { EmptyState } from '../empty_state/EmptyState';
import SubnavBar from '../subnav_bar/SubnavBar';
import {
	siteSurveyTemplatesRestCrudThunksForBuyer,
	siteSurveyTemplatesRestCrudThunksForSupplier,
} from '../../thunks/site_survey_templates_thunks';
import * as queryString from 'querystring';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import { withUserType } from '../withUserType';
import { ROLE_TYPES } from '../../utils/DataConstants';

const { Content } = Layout;

require('./SiteSurveyTemplatesIndexPage.less');

const SITE_SURVEYS_TEMPLATE_OVERVIEW_TARGET_COLLECTION = 'siteSurveyTemplatesIndex';

class SiteSurveyTemplatesIndexPage extends React.Component<any, any> {
	initialPagination: any = { current: 1, pageSize: 10 };
	constructor(props) {
		super(props);
		const { location } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const { current, pageSize } = queryParams;
		this.initialPagination = { current: current ? current : 1, pageSize: pageSize ? pageSize : 10 };
	}

	render() {
		const { history, userType } = this.props;
		const onRow = (record) => ({
			onClick: () => history.push(`/${userType}/siteSurveys/templates/detail/${record.id}`),
		});

		const columns = [
			{
				title: 'Name',
				dataIndex: 'name',
				defaultSortOrder: 'ascend',
				render: (text, record) => record.title,
			},
		];

		return (
			<Content className="siteSurveyTemplatesIndexPage" style={{ padding: '0 0.5em' }}>
				<div style={{ margin: '0.5em 0px' }}>
					<SubnavBar
						left={<div></div>}
						right={
							<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_SITE_SURVEY_TEMPLATES}>
								<Button
									type="primary"
									size="large"
									onClick={() =>
										this.props.history.push(`/${userType}/siteSurveys/overview/templates/new`)
									}
								>
									Add Site Survey Template
								</Button>
							</AccessPermissionChecker>
						}
					/>
				</div>
				<Row style={{ margin: '0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<Card bodyStyle={{ padding: 8 }}>
							<PaginatedReduxTable
								showHeader={false}
								emptyState={
									<EmptyState
										graphic={
											<img
												style={{ marginBottom: 8 }}
												src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
											/>
										}
										headline={"It's a little lonely in here."}
										body={
											<div style={{ textAlign: 'center' }}>
												<div style={{ maxWidth: 440, marginBottom: 16 }}>
													Looks like your team has not added any site surveys yet.
												</div>
												<Button
													type="primary"
													onClick={() =>
														this.props.history.push(
															`/${userType}/siteSurveys/overview/templates/new`
														)
													}
												>
													Add your first site survey template
												</Button>
											</div>
										}
									/>
								}
								updateQueryParams={true}
								onRow={onRow}
								collectionName="site_survey_templates"
								targetCollectionName={SITE_SURVEYS_TEMPLATE_OVERVIEW_TARGET_COLLECTION}
								columns={columns}
								keyAccessor={(el) => el.id}
								initialPagination={this.initialPagination}
								fetchData={
									userType === ROLE_TYPES.SUPPLIER
										? siteSurveyTemplatesRestCrudThunksForSupplier.read
										: siteSurveyTemplatesRestCrudThunksForBuyer.read
								}
							/>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

export default withUserType(
	withRouter<any, any>(connect()(SiteSurveyTemplatesIndexPage as any)) as any
);
